export enum EngineInternalEventsEnum {
    ASSET_SOURCE_REPLACED = "asset:source_replaced",
    CLIP_SOURCE_REPLACED = "clip:source_replaced",
    CLIP_REMOVED = "clip:internal_removed",
    CLIP_UPDATED = "clip:internal_updated",
    CLIP_ADDED = "clip:internal_added",
    SCRIPT_LAYER_UPDATED = "script:layer_updated",
}